// extracted by mini-css-extract-plugin
export var growableInput = "_8h-0";
export var tagContainer = "_8h-2";
export var textInput = "_8h-1";